import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { FiPaperclip } from "react-icons/fi";
import { GoTrash } from "react-icons/go";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import { formatarData } from "../../../Funcoes/FormatarData";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import ModalAnexosNfFaturamentoDireto from "./ModalAnexosNfFaturamentoDireto";

const Conteudo = styled.div`
    min-width: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
`;

const ResumoLinha = styled.div`
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 14px;
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    max-width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
    p {
        margin: 4px 0;
    }
`;

const TabelaScroll = styled.div`
    min-width: 0;
    width: 100%;
    max-width: 100%;
    max-height: min(62vh, 520px);
    overflow-x: auto;
    overflow-y: auto;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-sizing: border-box;
`;

const Tabela = styled.table`
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    color: #333;
    font-size: 13px;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 1;
    }
    thead th {
        text-align: left;
        padding: 10px 12px;
        font-weight: 600;
        color: #242d34;
    }
    thead th.colNum {
        width: 18%;
    }
    thead th.colData {
        width: 16%;
    }
    thead th.colValor {
        width: 20%;
    }
    thead th.colAnex {
        width: 48px;
        text-align: center;
        padding-left: 8px;
        padding-right: 8px;
    }
    thead th.acoes {
        text-align: center;
        width: auto;
        white-space: nowrap;
    }
    tbody td {
        padding: 10px 12px;
        border-top: 1px solid #e5e7eb;
        vertical-align: middle;
        overflow-wrap: break-word;
        word-break: break-word;
    }
    tbody td.colValor {
        white-space: nowrap;
    }
    tbody td.colAnex {
        text-align: center;
        vertical-align: middle;
        padding-left: 8px;
        padding-right: 8px;
    }
    tbody td.acoes {
        text-align: center;
        vertical-align: middle;
        overflow: visible;
        word-break: normal;
    }
    tbody tr:nth-child(even) {
        background-color: #fafafa;
    }
`;

const BotaoExcluir = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    max-width: 100%;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 600;
    color: #b91c1c;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
    &:hover:not(:disabled) {
        background: #fee2e2;
        border-color: #fca5a5;
    }
    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

const Lixeira = styled(GoTrash)`
    width: 14px;
    height: 14px;
`;

const BotaoAnexos = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: #f1f5f9;
    color: #334155;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
    &:hover {
        background: #e0f2fe;
        color: #0369a1;
    }
`;
const IcoClip = styled(FiPaperclip)`
    width: 20px;
    height: 20px;
`;

const Vazio = styled.p`
    margin: 20px 0;
    text-align: center;
    color: #64748b;
    font-size: 14px;
`;

const LoadingBox = styled.div`
    display: flex;
    justify-content: center;
    padding: 40px 0;
`;

const formatarEmissao = (valor) => {

    if (!valor) {
        return "—";
    }

    const s = String(valor).trim();
    const dataCurta = s.length >= 10 ? s.slice(0, 10) : s;

    try {
        return formatarData(dataCurta, false);
    } catch {
        return s;
    }

};

const ModalListaNFFaturamentoDireto = ({ numPedido, faturamento, onFechar, onAlterado }) => {

    const { id: idPc } = useParams();
    const { closeModal, openModal, isModalOpen } = useModal();
    const { notifySuccess, notifyError } = useToast();
    const api = useApi();

    const idFaturamento = faturamento?.id != null ? Number(faturamento.id) : null;

    const [loading, setLoading] = useState(true);
    const [nfs, setNfs] = useState([]);
    const [excluindoId, setExcluindoId] = useState(null);
    const [nfAnexosModal, setNfAnexosModal] = useState(null);

    useEffect(() => {

        const carregar = async () => {

            setLoading(true);
            try {

                let url = `/Painel/API/ControleMedicao/ListNfFaturamentoDireto/index.php?id_pc=${idPc}`;
                if (idFaturamento != null && !Number.isNaN(idFaturamento) && idFaturamento > 0) {
                    url += `&id_faturamento=${idFaturamento}`;
                }

                const { data } = await api.get(url);
                setNfs(Array.isArray(data?.nfs) ? data.nfs : []);

            } catch (e) {

                console.error(e);
                setNfs([]);

            } finally {

                setLoading(false);

            }

        };

        carregar();

    }, [idPc, idFaturamento]);

    const fechar = () => {

        closeModal();
        if (typeof onFechar === "function") {
            onFechar();
        }

    };

    const handleExcluir = async (nf) => {

        if (
            !window.confirm(
                `Remover a NF ${nf.num_nf || nf.id} deste faturamento direto?`
            )
        ) {
            return;
        }

        setExcluindoId(nf.id);

        try {

            const formData = new FormData();
            formData.append("id_nf", String(nf.id));
            formData.append("id_pc", String(idPc));

            await api.post(
                "/Painel/API/ControleMedicao/DeleteNfFaturamentoDireto/",
                formData
            );

            notifySuccess("Nota fiscal removida.");
            setNfs((prev) => prev.filter((row) => row.id !== nf.id));
            if (typeof onAlterado === "function") {
                await onAlterado();
            }

        } catch (err) {

            const msg = err?.response?.data?.message || "Erro ao remover a NF.";
            notifyError(typeof msg === "string" ? msg : "Erro ao remover a NF.");
            console.error(err);

        } finally {

            setExcluindoId(null);

        }

    };

    const filtroLinha =
        idFaturamento != null && !Number.isNaN(idFaturamento) && idFaturamento > 0;

    const abrirAnexosNf = (nf) => {

        setNfAnexosModal(nf);
        openModal("modalAnexosNfFatDireto");

    };

    return (
        <>
        <Overlay state={true}>
            <Modal header close={fechar} size="lg">
                <Conteudo>
                <ResumoLinha>
                    <p>
                        <b>NOTAS FISCAIS — FATURAMENTO DIRETO</b>
                    </p>
                    <p>
                        <b>PC Nº:</b> {numPedido || "—"}
                    </p>
                    {filtroLinha && (
                        <>
                            <p>
                                <b>DISCIPLINA:</b> {faturamento?.disciplina || "—"}
                            </p>
                            <p>
                                <b>Nº PEDIDO / FORNEC.:</b>{" "}
                                {faturamento?.num_pedido_fornec || "—"}
                            </p>
                        </>
                    )}
                    {!filtroLinha && (
                        <p style={{ color: "#64748b", fontSize: 13 }}>
                            Exibindo todas as NFs do pedido de compra (faturamento direto).
                        </p>
                    )}
                </ResumoLinha>
                {loading ? (
                    <LoadingBox>
                        <SmallLoading />
                    </LoadingBox>
                ) : nfs.length === 0 ? (
                    <Vazio>Nenhuma NF lançada para este pedido.</Vazio>
                ) : (
                    <TabelaScroll>
                        <Tabela>
                            <thead>
                                <tr>
                                    <th className="colNum">Nº NF</th>
                                    <th className="colData">Data de emissão</th>
                                    <th className="colValor">Valor da NF</th>
                                    <th className="colAnex">Anexos</th>
                                    <th className="acoes">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nfs.map((nf) => (
                                    <tr key={nf.id}>
                                        <td className="colNum">{nf.num_nf || "—"}</td>
                                        <td className="colData">{formatarEmissao(nf.data_emissao)}</td>
                                        <td className="colValor">{formatBRLFromCents(Number(nf.valor) || 0)}</td>
                                        <td className="colAnex">
                                            <BotaoAnexos
                                                type="button"
                                                title="Ver anexos desta NF"
                                                aria-label="Anexos da NF"
                                                onClick={() => abrirAnexosNf(nf)}
                                            >
                                                <IcoClip aria-hidden />
                                            </BotaoAnexos>
                                        </td>
                                        <td className="acoes">
                                            <BotaoExcluir
                                                type="button"
                                                disabled={excluindoId === nf.id}
                                                onClick={() => handleExcluir(nf)}
                                                title="Remover NF deste pedido"
                                            >
                                                <Lixeira aria-hidden />
                                                {excluindoId === nf.id ? "…" : "Apagar"}
                                            </BotaoExcluir>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Tabela>
                    </TabelaScroll>
                )}
                </Conteudo>
            </Modal>
        </Overlay>
        {isModalOpen("modalAnexosNfFatDireto") && nfAnexosModal && (
            <ModalAnexosNfFaturamentoDireto
                nf={nfAnexosModal}
                numPedido={numPedido}
                faturamento={faturamento}
                onFechar={() => setNfAnexosModal(null)}
            />
        )}
        </>
    );

};

export default ModalListaNFFaturamentoDireto;
